import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dropdown',
  templateUrl: './app-dropdown.component.html',
  styleUrls: ['./app-dropdown.component.scss']
})
export class AppDropdownComponent {
  private _options: any[] = [];

  @Input() isSearchInput:boolean=false;
  @Input() selectedOption: string; // Stores the selected option
  @Input() customValue!: string;
  @Input() id?:string;
  @Input() isRequired:boolean;
  @Input() dropdownLabel:string;
  @Input () optionDisable:boolean=false;
  highlightedIndex: number = -1
  @Input () isDatePipe:boolean=false
  @Input()
  set options(options: any[]) {
    this._options = options || []; // Ensure options is an array
    this.filteredOptions = [...this._options];
  }

  get options(): any[] {
    return this._options;
  }

  @ViewChild('dropdown') dropdown:NgbDropdown;

  @Output() dropdownValueEmit:EventEmitter<string> = new EventEmitter();
  @Output() searchValueEmit :EventEmitter<string> = new EventEmitter();
  @Input() selectedId: any;
  @Input() labelName:string;
  searchInput: string = '';
  filteredOptions:any[] = [];;

  selectOption(option){
      this.selectedOption = option?.name;
      this.searchValueEmit.emit(option?.name);
      this.dropdownValueEmit.emit(option?.id);
      this.selectedId = option?.id;
      this.customValue = '';
      this.searchInput = '';
      this.filteredOptions = [...this._options];
      this.highlightedIndex = -1; 
      this.dropdown.close();
  }

  reset(){
    this.selectedOption=null;
    this.selectedId=null;
    this.highlightedIndex = -1; 
  }

  clearSearch() {
    this.searchInput = '';
    this.filteredOptions = [...this._options];
    this.highlightedIndex = -1;
  }

  onEnter() {
    this.selectedOption = this.searchInput;
    this.customValue = this.searchInput;
    this.searchValueEmit.emit(this.searchInput);
    this.selectedId = null;
    this.highlightedIndex = -1;
    this.dropdown.close();
  }

 filterOptions() {
    if (this.searchInput.trim()) {
      this.filteredOptions = this._options?.filter(option => 
        option.name.toLowerCase().includes(this.searchInput.toLowerCase())
      );
    } else {
      this.filteredOptions = [...this._options];
    }
    this.highlightedIndex = -1;
  }

  // #region for highlighted option during up and down key start

  highlightNext() {
    if (this.highlightedIndex < this.filteredOptions.length - 1) {
      this.highlightedIndex++;
    }
  }

  highlightPrevious() {
    if (this.highlightedIndex > 0) {
      this.highlightedIndex--;
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (!this.dropdown.isOpen()) return;
    if (event.key === 'ArrowDown') {
      this.highlightNext();
      event.preventDefault();
    } else if (event.key === 'ArrowUp') {
      this.highlightPrevious();
      event.preventDefault();
    } else if (event.key === 'Enter' && this.highlightedIndex >= 0) {
      this.selectOption(this.filteredOptions[this.highlightedIndex]);
      event.preventDefault();
    }
  }

  get selectedDisplayValue(): string | null {
    if (this.customValue && !this.selectedId) {
      return this.customValue;
    }
    const match = this.options?.find(opt => opt.id == this.selectedId);
    return match?.name ?? null;
  }

  // #region for highlighted option during up and down key End


}
